var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dropdown',{key:'locale-' + _vm.id,attrs:{"dropdownId":'locale-' + _vm.id,"options":_vm.localeOptions,"placeholder":"Select a locale"},on:{"updateOption":_vm.updateLocale}})}
var staticRenderFns = []

export { render, staticRenderFns }